// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
// COMPONENTS
import MUIDataTable from "mui-datatables";
// ICONS
import { HiCheck } from 'react-icons/hi';
import { CgClose } from 'react-icons/cg';
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import SelectBlock from '../../components/SelectBlock';
import Button from '../../components/Button';
import LoadingScreen from '../../components/LoadingScreen';

import * as Helper from '../../helpers/helper';
import * as CompanyService from '../../services/company.service';
import * as UserService from '../../services/user.service';

const UserListingPage = (props) => {
    const role = Helper.LoggedInUserRole();
    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(Helper.LoggedInCompanyId());
    const [data, setData] = useState([]);

    useEffect(() => {
        if (role == 'SuperAdmin') {
            setLoading(true);
            CompanyService.GetAll().then(res => {
                setCompanies(res);
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
            LoadUsers(0);
        }
        else
            LoadUsers(selectedCompany);
    }, []);

    const LoadUsers = (companyId) => {
        setLoading(true);
        UserService.GetAll(companyId).then(res => {
            if(role != 'SuperAdmin'){
                res = _.filter(res, x => x.companyId != null);
                console.log(res);
                setData(res);
            }
            else{
            setData(res);

            }
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const columns = [
        {
            name: 'id',
            label: 'Action',
            options: {
                filter: false,
                sort: false,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <CustomBlock className="content-container--actions pl-0 mt-0" style={{ justifyContent: "flex-start" }}>
                            <Button
                                text={data[dataIndex].companyId ? "Edit" : "View"}
                                to={"/user/" + data[dataIndex].id}
                                size="xs"
                                className="primary--bg"
                            />
                            <Button
                                text={"Top 20"}
                                to={"/client-list/" + data[dataIndex].id}
                                size="xs"
                                className="info--bg"
                                style={{minWidth: 75}}
                            />
                        </CustomBlock>

                    );
                }
            }
        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].firstName} {data[dataIndex].lastName}
                        </>
                    );
                }
            }
        },
        {
            name: "username",
            label: "Username",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "isAdmin",
            label: "Admin?",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].isAdmin ? <HiCheck size={25} className="success--clr" /> : <CgClose size={25} className="danger--clr" />}
                        </>
                    );
                }
            }
        },
        {
            name: "isSalesCoach",
            label: "Sales Coach?",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].isSalesCoach ? <HiCheck size={25} className="success--clr" /> : <CgClose size={25} className="danger--clr" />}
                        </>
                    );
                }
            }
        }
    ];

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style">
                                <ContentHeader
                                    title="Users"
                                    headerSize="mdlg"
                                    primaryButtonText="Add"
                                    primaryButtonTo="/add-new-user"
                                    primaryButtonBackgroundColor="success--bg"
                                />
                                <Section removeContainer>
                                    {
                                        role == "SuperAdmin" ?
                                            <ContentBlock>
                                                <SelectBlock
                                                    id="companyId"
                                                    name="companyId"
                                                    inputLabel="Company"
                                                    bordered
                                                    value={selectedCompany}
                                                    options={companies.map(x => Helper.SetOptionModel(x.businessName, x.id))}
                                                    onChange={option => {
                                                        option = option === null ? [] : option;
                                                        setSelectedCompany(option);
                                                        LoadUsers(option.value);
                                                    }}
                                                />
                                            </ContentBlock> : <></>
                                    }
                                    <ContentBlock>
                                        <MUIDataTable
                                            data={data}
                                            columns={columns}
                                            options={{
                                                selectableRows: "none"
                                            }}
                                        />
                                    </ContentBlock>
                                </Section>
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    )
}

export default UserListingPage;